var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 972,
    viewBox: "0 0 1920 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1048.25 204.936L1047.85 202.882L1126.43 175.451L1130.13 0.690422L1131.74 0.74936L1128 177.092L1048.25 204.936Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.7 282.735L1126.4 176.974L1130.14 0.690409H1130.93L1131.53 -0.0252609L1329.61 281.009L1328.7 282.735ZM1128.03 175.56L1325.98 279.039L1131.69 3.35105L1128.03 175.56Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.903 342.296L84.2754 286.271L286.515 182.826L286.803 183.811L287.527 184.308L224.903 342.296ZM89.2226 286.019L224.109 339.762L285.146 185.824L89.2226 286.019Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.04 342.422L286.125 183.331L286.835 183.811L287.507 183.247L350.79 314.839L223.04 342.422ZM286.906 185.95L225.958 339.635L348.122 313.256L286.906 185.95Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.462 315.193L469.958 151.85L470.528 152.583H471.347L473.734 309.569L347.462 315.193ZM469.76 155.159L351.45 312.894L472.096 307.497L469.76 155.159Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.712 334.567L472.121 309.442V308.55L469.76 152.633H470.566L471.149 151.917L599.712 334.567ZM473.702 307.624L595.405 331.595L471.379 155.361L473.702 307.624Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.984 333.977L597.043 332.293L725.043 190.412L801.44 165.498L802.08 167.443L597.984 333.977ZM725.76 192.324L606.553 324.514L796.825 169.195L725.76 192.324Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.03 356.938L937.587 305.847L938.035 303.793L1068.95 353.932L1047.25 204.103L1048.83 203.699L1071.03 356.938Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.6 457.428L1069.24 355.995L1069.19 355.658L1047.24 204.103L1048.02 203.909L1048.74 203.404L1149.86 456.148L1148.6 457.428ZM1070.72 354.909L1146.07 451.239L1049.84 210.67L1070.72 354.909Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.44 457.141L1046.86 203.202L1127.9 174.92L1128.01 176.158L1149.95 456.535L1148.44 457.141ZM1049.24 204.549L1147.92 451.247L1126.5 177.606L1049.24 204.549Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.44 457.63L1148.66 455.786L1328.36 281.059L1328.89 279.78L1330.11 281.985L1329.59 282.491L1288.42 380.412L1288.16 380.555L1149.44 457.63ZM1326.47 285.539L1155.08 452.199L1287.3 378.745L1326.47 285.539Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.49 458.606L1126.27 174.634L1330.66 281.455L1148.49 458.606ZM1128.14 177.892L1149.8 454.683L1327.36 282.044L1128.14 177.892Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.97 402.699L1286.61 380.311L1328.9 279.771L1329.75 281.354L1365.97 402.699ZM1289.09 378.829L1363.37 399.794L1328.88 284.234L1289.09 378.829Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.92 401.647L1327.86 280.815L1368.63 276.698L1365.47 401.31L1363.92 401.647ZM1330.16 282.718L1364 396.09L1366.95 278.988L1330.16 282.718Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.94 402.253L1364.28 400.316L1577.39 248.77L1578.16 250.63L1374.28 395.618L1487.95 342.363L1488.49 344.367L1364.94 402.253Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.84 403.061L1367.04 276.875L1367.74 276.782L1577.69 248.618L1578.16 250.605L1363.84 403.061ZM1368.59 278.803L1365.54 399.449L1573.86 251.262L1368.59 278.803Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 419.556V423.311L36.5632 493.776L0 487.259V489.397L39.936 496.512L0 419.556Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 325.76V333.06L35.9552 488.833L0 419.556V423.311L37.5872 495.737L39.0272 494.837L0 325.76Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7681 497.918L85.9265 286.044V285.623L88.2113 283.501L87.5713 286.28L96.3777 439.645L36.7681 497.918ZM86.2593 291.862L39.7441 492.37L94.7201 438.635L86.2593 291.862Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 208.751V211.293L85.8048 286.583L38.2592 491.502L0 325.76V333.06L38.2528 498.777L87.6992 285.69L0 208.751Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.054 525.417L94.7648 439.94L85.9072 285.665L86.7776 284.823L87.2576 285.328L306.778 523.607L306.054 525.417ZM96.288 438.332L302.643 521.813L87.68 288.528L96.288 438.332Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.779 525.223L86.2593 286.945L87.0081 285.101L225.056 340.115L306.982 523.868L305.779 525.223ZM90.3681 288.688L303.29 519.784L223.962 341.926L90.3681 288.688Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.4 537.567L378.809 437.961L348.685 314.376L349.165 314.166L350.009 313.273L523.334 535.883L522.4 537.567ZM380.16 436.488L518.233 532.287L351.193 317.778L380.16 436.488Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.39 540.202L347.52 313.054L473.504 307.438L524.39 540.202ZM351.36 315.008L521.158 533.079L472.32 309.611L351.36 315.008Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.354 537.415L522.074 536.194L597.888 329.751L611.098 419L523.354 537.415ZM597.235 336.436L525.658 531.243L609.357 418.293L597.235 336.436Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.586 539.604L471.795 307.219L598.765 332.234L522.586 539.604ZM474.035 309.821L522.97 533.685L596.359 333.918L474.035 309.821Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.298 582.629L609.498 419.227L596.774 333.279L597.6 333.043L598.163 332.369L767.398 581.088L766.298 582.629ZM610.97 418.048L759.91 573.275L598.912 336.68L610.97 418.048Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.36 584.17L596.083 332.495L597.363 332.049L806.694 259.766L767.36 584.17ZM599.04 333.657L766.272 579.446L804.717 262.645L599.04 333.657Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.053 582.814L766.547 580.802L955.699 497.842L937.018 304.955L938.611 304.685L957.459 499.307L767.053 582.814Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.203 304.201L766.208 581.208L767.46 582.546L938.455 305.539L937.203 304.201Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.203 304.201L766.208 581.208L767.46 582.546L938.455 305.539L937.203 304.201Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.08 554.448L955.827 499.282L955.77 498.71L937.018 304.955L937.83 304.811L938.522 304.315L1043.08 554.448ZM957.318 497.868L1039.24 549.683L939.149 310.2L957.318 497.868Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.53 555.147L1040.45 552.621L936.173 303.085L1070.92 354.707L1070.78 355.667L1041.53 555.147ZM939.462 306.563L1040.79 548.984L1069.06 356.172L939.462 306.563Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.27 553.337L1148.54 455.904L1148.69 455.584H1151.8L1149.73 457.402L1108.04 548.335L1038.27 553.337ZM1146.58 460.206L1044.04 550.786L1107.11 546.247L1146.58 460.206Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 554.364L1069.48 353.309L1150.44 456.796L1040 554.364ZM1070.5 357.561L1042.31 549.758L1147.87 456.501L1070.5 357.561Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.42 613.833L1106.41 547.805L1148.69 455.584H1149.56L1149.81 456.038L1233.42 613.833ZM1108.77 546.736L1229.04 609.269L1149.2 458.556L1108.77 546.736Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.5 613.917L1147.92 456.181L1289.17 377.701L1231.5 613.917ZM1150.39 457.116L1230.97 609.185L1286.56 381.448L1150.39 457.116Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.62 612.477L1230.61 610.877L1364.05 400.569L1365.45 401.411L1344.21 529.837L1343.89 530.065L1231.62 612.477ZM1363.2 405.225L1234.64 607.829L1342.8 528.44L1363.2 405.225Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.84 612.233L1230.47 611.223L1287.31 378.333L1366.14 400.577L1231.84 612.233ZM1288.4 380.808L1233.28 606.701L1363.2 401.908L1288.4 380.808Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.8 671.617L1342.58 529.677L1364.23 398.91L1365.28 400.594L1536.8 670.026L1535.8 671.617ZM1344.44 528.608L1532.78 666.953L1365.12 403.541L1344.44 528.608Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.56 674.514L1535.56 671.365L1363.31 400.754L1488.83 341.951L1537.56 674.514ZM1366.04 401.714L1534.81 666.852L1487.61 344.771L1366.04 401.714Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 462.917L1838.64 688.389L1724.25 607.686L1920 432.758V430.19L1721.14 607.897L1838.62 690.772L1839.37 691.311L1920 467.868V462.917Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 657.641L1840.5 688.162L1920 467.868V462.917L1837.5 691.538L1920 659.863V657.641Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1488 494.828L39.3024 494.053L38.5856 494.087L37.8368 493.085L37.6256 494.112L0 495.367V497.489L37.1968 496.251L7.616 642.712L0 630.403V633.771L8.3648 647.276L38.8736 496.192L40.1472 496.142L39.1488 494.828Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 487.259V489.406L28.1728 494.424L0 495.367V497.489L38.2784 496.209L38.368 494.104L0 487.259Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82861 646.644L37.8366 493.085L38.8222 494.39L129.062 592.329L6.82861 646.644ZM38.707 497L9.15821 643.369L125.785 591.529L38.707 497Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.877 594.88L36.9536 495.114L96 437.355L128.877 594.88ZM39.5712 495.19L125.971 588.986L95.0592 440.917L39.5712 495.19Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.318 555.265L304.96 524.55L378.938 436.437L380.218 437.65L341.318 555.265ZM307.61 524.263L340.602 552.15L377.242 441.304L307.61 524.263Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.902 586.696L456.608 586.62L340.768 554.735L340.877 552.638L522.682 535.596L523.046 537.163L523.136 537.567L456.902 586.696ZM346.778 554.255L456.646 584.49L519.238 538.08L346.778 554.255Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.33 665.303L455.04 585.652L522.381 535.731L522.822 536.573L523.462 536.102L578.33 665.303ZM458.509 585.526L574.4 660.411L522.458 538.089L458.509 585.526Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.749 665.942L521.773 536.481L611.501 415.405L576.749 665.942ZM523.763 536.834L575.968 659.762L608.967 421.854L523.763 536.834Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.493 663.905L576.109 661.85L766.554 580.802L767.047 582.814L586.931 659.485L709.293 632.786L709.555 634.882L576.493 663.905Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.36 664.418L609.709 416.71L768.518 582.217L575.36 664.418ZM610.809 420.566L577.395 661.295L765.113 581.417L610.809 420.566Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.491 634.882L709.351 632.76L932.698 607.669L766.707 582.856L766.893 580.76L940.935 606.76L940.922 608.882L709.491 634.882Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.498 608.983L940.755 608.882L766.72 582.882L766.56 580.827L957.626 497L941.498 608.983ZM770.522 581.29L940.192 606.659L955.552 500.149L770.522 581.29Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.33 779.828L939.623 607.358L1042.06 550.398L1029.33 779.828ZM942.08 608.301L1028.08 773.614L1040.28 553.707L942.08 608.301Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.782 609.581L955.974 497L1043.12 552.099L939.782 609.581ZM957.171 500.124L941.92 606.078L1039.2 551.99L957.171 500.124Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.08 780.417L1039.7 551.097L1108.18 546.163L1108.35 547.005L1157.51 779.558L1156.08 780.417ZM1042.61 553.009L1154.61 773.74L1106.98 548.361L1042.61 553.009Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.2 781.158L1232 607.627V611.349L1275.52 760.252L1155.2 781.158ZM1231.08 614.035L1158.27 778.531L1273.34 758.551L1231.08 614.035Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.48 782.539L1106.37 545.506L1107.87 546.281L1232.4 611.02L1231.92 612.081L1156.48 782.539ZM1108.79 549.043L1157.01 777.125L1230.05 612.098L1108.79 549.043Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.7 759.764L1230.43 611.761V609.126L1231.78 610.768L1333.42 734.378L1332.33 735.936L1233.22 615.416L1275.21 758.997L1273.7 759.764Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.56 737.435L1332.33 735.936L1229.88 611.324L1344.43 527.269L1333.56 737.435ZM1232.6 611.761L1332.19 732.871L1342.59 531.016L1232.6 611.761Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 736.517L1342.78 527.396L1538.37 671.078L1332 736.517ZM1344.22 530.89L1333.75 733.806L1534 670.304L1344.22 530.89Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.85 760.791L1536.64 694.511L1535.36 670.279L1536.14 669.251L1536.7 669.866L1617.78 759.065L1616.85 760.791ZM1538.13 693.281L1607.68 750.696L1537.13 673.074L1538.13 693.281Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.34 762.433L1535.14 670.876L1535.57 670.034L1597.31 551.215L1597.58 553.952L1618.34 762.433ZM1537.28 670.489L1616.22 757.33L1596.24 557.016L1537.28 670.489Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.48 778.346L1615.64 760.665L1722.11 607.046L1722.86 607.787H1723.5L1718.48 778.346ZM1618.91 759.107L1716.95 775.946L1721.81 610.667L1618.91 759.107Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.7 762.29L1616.47 760.025L1595.78 552.621L1724.16 607.299L1616.7 762.29ZM1597.72 555.661L1617.84 757.473L1721.27 608.284L1597.72 555.661Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.08 847.413L1716.89 777.917V777.075L1721.89 607.467L1722.53 606.028L1723.27 607.03L1894.08 847.413ZM1718.55 776.351L1888.83 843.153L1723.42 610.338L1718.55 776.351Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890.86 846.015L1722.11 608.511L1723.08 606.827L1839.62 689.046L1839.73 689.4L1892.21 844.845L1890.86 846.015ZM1726.62 611.761L1888.78 839.936L1838.37 690.654L1726.62 611.761Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 819.022L1897.64 838.598L1920 808.968V805.971L1890.87 844.533L1891.89 846.175L1920 821.573V819.022Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 805.954L1891.72 843.447L1840.11 690.528L1920 659.863V657.657L1837.89 689.173L1891.19 847.127L1920 808.969V805.954Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 630.403V633.771L7.1296 645.306L0 695.807V707.427L8.8512 644.708L0 630.403Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 753.466V756.429L127.078 593.853L183.437 809.154L0 767.695V769.85L185.85 811.873L128.352 592.228L129.024 591.369L128.038 591.04L127.776 590.013L127.187 590.754L126.182 590.417L126.502 591.655L0 753.466Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 707.427L8.6976 645.819L124.314 594.434L0 753.466V756.429L127.994 592.682L127.174 590.931L7.2896 644.194L0 695.807V707.427Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.95 762.273L340.793 551.779L341.709 553.32L392.435 728.164L258.95 762.273ZM340.87 556.292L261.901 759.351L390.24 726.565L340.87 556.292Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.898 844.82L390.682 728.063L340.211 554.078L340.954 553.69L341.594 553.008L524.986 843.262L523.898 844.82ZM392 726.666L520.192 839.027L343.443 559.306L392 726.666Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.725 844.618L338.861 552.023L457.389 584.667L457.536 585.239L525.107 843.591L523.725 844.618ZM343.04 555.349L522.157 838.842L456.166 586.494L343.04 555.349Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.893 857.643L523.226 844.82L575.75 661.977L576.973 661.564L577.146 662.659L606.893 857.643ZM525.44 843.052L604.851 855.218L576.09 666.7L525.44 843.052Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.314 847.06L455.373 583.522L577.363 662.347L524.314 847.06ZM458.17 587.664L524.384 840.812L575.36 663.391L458.17 587.664Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.094 856.641L575.667 663.686L573.485 662.718L576.973 661.564L577.056 662.061L799.93 760.723L799.418 762.736L577.421 664.461L606.669 856.229L605.094 856.641Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.418 762.736L576.103 663.871L576.231 661.808L709.293 632.786L709.555 634.882L579.68 663.206L799.93 760.723L799.418 762.736Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.186 762.559L799.162 760.909L938.349 609.185L709.491 634.882L709.351 632.76L943.354 606.499L800.186 762.559Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.216 848.314L939.904 604.142L1029.83 777.016L949.216 848.314ZM941.805 611.509L950.688 844.424L1027.58 776.409L941.805 611.509Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.91 887.491L1537.06 692.38L1618.8 759.881L1462.91 887.491ZM1537.7 695.42L1466.88 881.782L1615.74 759.924L1537.7 695.42Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.69 972L1614.66 758.366L1718.2 776.14L1808.89 970.636L1807.69 972ZM1619.9 761.38L1804.92 966.14L1717.24 778.093L1619.9 761.38Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.51 971.756L1715.92 775.323L1891.69 844.264L1891.23 846.302L1719.5 778.935L1808.89 970.644L1807.51 971.756Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 819.022L1891.01 844.39L1891.9 846.175L1920 821.573V819.022Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.282 913.23L390.567 728.636L260.576 761.86L260.275 759.764L392.109 726.093L397.895 913.129L396.282 913.23Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.326 914.737L390.47 725.293L526.08 844.163L396.326 914.737ZM392.211 729.385L397.843 911.588L522.643 843.692L392.211 729.385Z",
    fill: "#E7E5E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 972,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.99c07e5963a6949702c6a6213e5bbd14.svg";
export { ForwardRef as ReactComponent };